<kendo-radialgauge  style="display:block;height:125px;width:125px;"
                    [pointer]="{ value: measurement.val, color: 'DarkBlue', length: 1.2 }"     >
  <kendo-radialgauge-scale [majorUnit]="GetNumberOfUnitsOnScale()" [min]= "GetScaleMin()" [max]="GetScaleMax()"
                           [majorTicks]="{ visible: false, color: 'lightgray' }"
                           [minorTicks]="{ visible: false, color: 'red' }"
      >
    <kendo-radialgauge-scale-ranges>
      <kendo-radialgauge-scale-range [from]="setting.val" [to]="GetScaleMax()" color="lightgray">
      </kendo-radialgauge-scale-range>
      <kendo-radialgauge-scale-range [from]="GetScaleMin()" [to]="setting.val" color="lightgreen">
      </kendo-radialgauge-scale-range>
    </kendo-radialgauge-scale-ranges>
  </kendo-radialgauge-scale>
</kendo-radialgauge>
<b>{{GetValueAsString() }}</b>  <app-unit [unit]="this.complexObject.actual.variable.unit"></app-unit> <br/>
<small>{{GetDescription()}} </small>

